import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import Co2Footprints from 'components/desktop/_general/Co2Footprint/Co2Footprints';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import ENTITLEMENTS from 'enums/entitlements';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

const TabCo2Footprints = ({ state, handlers }: IngredientTabProps) => {
	const baseIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEBASEINGREDIENT,
	]);

	return (
		<RenderIf entitlements={[ENTITLEMENTS.CARBONDIOXIDE]}>
			<Co2Footprints
				disabled={!baseIngredientEditor}
				characteristic={state.characteristic}
				footprints={state.co2Footprints}
				setFootprints={handlers.setCo2Footprints}
			/>
		</RenderIf>
	);
};

export default TabCo2Footprints;
